import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators,} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private fb: FormBuilder,
  ) {}

  loginFormGroup(): FormGroup {
    return this.fb.group({
      otp: [''],
      phoneNumber:[''],
    });
  }
  loginOtpFormGroup(): FormGroup {
    return this.fb.group({
      phoneNumber: ['']
    });
  }

}
